export default __webpack_public_path__ + "static/media/card.817db6d4.png";